<app-navbar></app-navbar>
<main>
  
  <section class="header relative pt-16 items-center flex mt-36 ">
    <div class="container mx-auto px-4 ">
      <div class="items-center flex flex-wrap justify-center ">
        <h3 class="font-semibold tracking-wide text-3xl text-center info-color">Get in Touch with Banan</h3>
      </div>
      <p class=" text-xl lg:text-2xl mt-4 info-color text-center  leading-10">We’re here to help! Whether you have questions or are ready to join, reach out:</p>

      <div class="mx-auto mt-16 grid max-w-2xl flex-wrap gap-6  sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:gap-8">
        <div class="flex gap-x-4 rounded-xl bg-white/5 p-6 ring-1 ring-inset ring-white/10">

          <div>

            <h3 class="font-semibold mr-5 "> <i class="fa-sharp fa-solid fa-phone mr-4"></i>  Support</h3>
            <p class="mt-2 text-gray-600">
              +986 24967868<br>
              <a class="hover:text-gray-300" href="mailto:info@banan.om">info@banan.om </a>
            </p>
          </div>
        </div>
        <div class="flex gap-x-4 rounded-xl bg-white/5 p-6 ring-1 ring-inset ring-white/10">

          <div>

            <h3 class="font-semibold mr-5 "> <i class="fa-solid fa-location-dot mr-4"></i>Address</h3>
            <p class="mt-2 text-gray-600">
              Muscat, Oman<br>
              Al Noor Plaza,Al Bashair St
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="h-200-px">
  </section>
</main>


<app-footer></app-footer>